// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsIndicatorsTemplate_heading__3-PsH"};